import { useMediaQuery } from "@mui/material";
import Onboarding1 from "src/onboardingModule/components/onboardingBigScreen";
import GuestPopup from "./GuestPopup";
import { useEffect } from "react";
import { WEB_ENGAGE } from "@utils/constants";
import { trackEvent } from "@utils/analytics/event-analytics";
function GuestUserModal({
  isLoginModalOpen,
  setLoginModalOpen,
  handleBlogLoginModal
}) {
  const smallScreen = useMediaQuery("(max-width:750px)");
  useEffect(() => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN
    });
  }, []);
  return <>
      {!smallScreen ? <Onboarding1 isLoginModalOpen={isLoginModalOpen} handleClose={() => setLoginModalOpen(false)} /> : <GuestPopup open={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} handleBlogLoginModal={handleBlogLoginModal} />}
    </>;
}
export default GuestUserModal;